import React from "react";
import { StyledText } from "./styles";

export const GradientText: React.FC<{ children: React.ReactNode }> = ({ children, ...otherProps }) =>
  <StyledText {...otherProps}>
    {children}
  </StyledText>